import { getPublicConfig } from '../../@data-loaders/get-public-config';
import { MH_API_URL } from '../../shared/constants';
import { once } from '../../shared/once';

export const handleRedirectCallback = once(async (auth0Client, url?: string) => {
    return auth0Client.handleRedirectCallback(url);
});

export const getAuth0Client = once(async () => {
    const publicConfig = await getPublicConfig();
    const redirect_uri = `${window.location.origin}/authorized`;
    const auth0Client = window.auth0.createAuth0Client({
        domain: publicConfig.integrations.auth0.domain,
        clientId: publicConfig.integrations.auth0.clientId,
        cacheLocation: `localstorage`,
        authorizationParams: {
            audience: MH_API_URL,
            redirect_uri,
        },
    });
    return auth0Client;
});
